import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@mui/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';

import TooltipBlack from 'libraries/Tooltip';
import {
    AI_LIGHT_GRADING_REQUIRED, AI_LIGHT_INITIAL, AI_LIGHT_OPTIMIZED,
    MANUAL_GRADED, MANUAL_GRADING_REQUIRED,
    SPREADSHEET, CODE_TEST, CODE_TEST_AUTOGRADED,
    PRESENTATION, ANY_FILE
} from 'helper/constants';
import InsightsIcon from '../../assets/insightsIcon';
import CorrectAnswerIcon from '../../assets/correntAnswerIcon';
import InstructionsIcon from '../../assets/instructionsIcon';

const styles = theme => ({
    list: {
        display: 'flex'
    },
    listIcon: {
        minWidth: 25
    },
    listRoot: {
        whiteSpace: 'nowrap',
        padding: 8,
        borderRadius: 4
    },
    activeListRoot: {
        '& path, & rect, & ellipse': {
            stroke: theme.palette.primary.main
        }
    }
});

const IconMenu = ({ classes, openedSection, handleOpenDrawer, noExampleAnswers, questionStatus, questionAnswerType }) => {
    const menuItems = [{
        active: openedSection === 'instructions',
        name: 'instructions',
        onClick: () => handleOpenDrawer('instructions'),
        icon: <InstructionsIcon />,
        tooltipText: 'Scoring Instructions'
    }, {
        active: openedSection === 'correct-answer',
        name: 'correct-answer',
        onClick: () => handleOpenDrawer('correct-answer'),
        icon: <CorrectAnswerIcon noExampleAnswers={noExampleAnswers} />,
        tooltipText: 'Correct answer examples',
        hide: [SPREADSHEET, CODE_TEST, CODE_TEST_AUTOGRADED, PRESENTATION, ANY_FILE].includes(questionAnswerType)
    }, {
        active: openedSection === 'question-insights',
        name: 'question-insights',
        onClick: () => handleOpenDrawer('question-insights'),
        icon: <InsightsIcon />,
        tooltipText: 'Question Insights',
        hide: [AI_LIGHT_OPTIMIZED, AI_LIGHT_INITIAL, AI_LIGHT_GRADING_REQUIRED, MANUAL_GRADED, MANUAL_GRADING_REQUIRED].includes(questionStatus)
    }];

    return (
        <List className={classes.list}>
            {menuItems.map(({ active, name, onClick, icon, tooltipText, hide }) => (hide ? null : (
                <ListItem
                    key={name}
                    className={clsx(classes.listRoot, active && classes.activeListRoot)}
                    button
                    onClick={onClick}
                >
                    <TooltipBlack label={tooltipText}>
                        <ListItemIcon className={classes.listIcon}>
                            {icon}
                        </ListItemIcon>
                    </TooltipBlack>
                </ListItem>
            )))}
        </List>
    );
};

export default withStyles(styles)(IconMenu);
